import { ApplicationState } from 'AppReducer'
import React from 'react'
import { useSelector } from 'react-redux'
import BalanceItem from './BalanceItem'

const DemandPartner: React.FC = () => {
  const { payments } = useSelector((state: ApplicationState) => state.balanceReducer)

  const gridTemplateColumns = '200px 1fr 150px 200px 220px 220px 48px'

  return (
    <div className="row margin-top-32">
      <h2 className="row justify-start">
        <i className="fa fa-history"/> Extrato
      </h2>

      <div className="list">
        <div className="list-header" style={{ display: 'grid', gridTemplateColumns }}>
          <div>Tipo</div>
          <div>Descrição</div>
          <div>Valor</div>
          <div>Data</div>
          <div>De</div>
          <div>Para</div>
        </div>
        {
          payments.map((payment, i) => <BalanceItem key={i} payment={payment} />)
        }
        {
          payments.length === 0 &&
          <div className="row panel">Nenhum registro encontrado</div>
        }
      </div>
    </div>
  )
}

export default DemandPartner
